module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAaBAMAAABBWLFzAAAAMFBMVEUAAAD////////8/Pz////+/v7///////////////////////////////////////82kFpEAAAAEHRSTlMABxQkLjtIXnCBjpqnu8bMb79PCgAAAO1JREFUeNo9j71OAkEUhQ+zQtZgMY+gNlTqE0goLEnkDQwPYLAmmOUNSCwsbLC108ZWCdZu1oaEZho6ik0Ewt/uHu7MireYfPnOnZt7AagOmb1r2LqlraFF3yGzhnCP6eNVm5wARfJBTJ2pxhFXKJxChezihq+4z75wzgh91nz70+cCYYprGRN5XCLeyCRyXoiF19JGaTBLmC0C4V8l/iPTZ8LPJekPeHdgmByXOcMFf1B5aaLFTxyKkx1KMRtQhiMN1edaTJWcPn2TA2HPuP1dJy4dD9yNLkjye13wlqMNtn/aBnstwfhfAyfu3QFZNJCqxFt18QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/storefront/orientation.png
// module id = 8Gmr
// module chunks = 1